import { AudioEncoding } from '../../audio/AudioEncoding'
import { GET_AUDIO_STREAM_UI_CONTEXT } from '../../apollo/actions'
import { logger } from '../../lib/logging'
import get from 'lodash.get'

const defaults = {
  audioStreamUIContext: {
    __typename: 'AudioStreamUIContext',
    agentAwake: false,
    noteId: '',
    sectionId: '',
    noteTypeId: '',
    problemBasedSections: [],
    patientId: '',
    transcription: false,
    isScriptChange: false
  },
  audioStreamFormat: {
    __typename: 'AudioStreamFormat',
    channels: 1,
    bitDepth: 16,
    encoding: AudioEncoding.LINEAR16,
    sampleRate: null,
    source: null
  },
  isProcessed: true,
  socket: {
    __typename: 'SocketData',
    isAuthenticated: false
  },
  createNote: false
}

const resolvers = {
  Mutation: {
    setAudioStreamUIContext: (_, { audioStreamUIContext }, { cache }) => {
      console.info('Sent audioStream context:', audioStreamUIContext)
      logger.info(`Updating audioStream context to: ${JSON.stringify(audioStreamUIContext)}`)
      // [TODO: this code become a utility library perhaps]
      const { audioStreamUIContext: oldContext } = cache.readQuery({
        query: GET_AUDIO_STREAM_UI_CONTEXT
      })
      const updatedContext = { ...oldContext, ...audioStreamUIContext }

      let pbSections = get(updatedContext, 'problemBasedSections', [])
      pbSections = pbSections.map(s => ({ __typename: 'AudioStreamPbSectionContext', idNamePair: s.idNamePair }))

      const data = {
        audioStreamUIContext: {
          __typename: 'AudioStreamUIContext',
          ...updatedContext,
          problemBasedSections: pbSections
        }
      }
      cache.writeData({ data })
      return null
    },
    setAudioStreamFormat: (_, { audioStreamFormat }, { cache }) => {
      const data = {
        audioStreamFormat: {
          __typename: 'AudioStreamFormat',
          ...audioStreamFormat
        }
      }
      cache.writeData({ data })
      return null
    },
    setSocketAuthenticated: (_, { isSocketAuthenticated }, { cache }) => {
      const data = {
        socket: {
          __typename: 'SocketData',
          isAuthenticated: isSocketAuthenticated
        }
      }
      cache.writeData({ data })
      return null
    },
    setAudioProcessed: (_, { isProcessed }, { cache }) => {
      const data = {
        isProcessed
      }
      cache.writeData({ data })
      return null
    },
    setCreateAmwellNote: (_, { createNote }, { cache }) => {
      const data = {
        createNote
      }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
